import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LaminationService } from '@app/shared/services/lamination.service';

import { TempRemaService } from '@app/shared/services/temp-rema.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

import * as XLSX from 'xlsx';
import { FormsModule } from '@angular/forms';  // <-- Add this


@Component({
  selector: 'app-rema-test-table',
  templateUrl: './rema-test-table.component.html',
  styleUrls: ['./rema-test-table.component.css']
})
export class RemaTestTableComponent implements OnInit {
  
 
   //table
   materialMixEntries: any[] = [];
   currentPage: number = 1;
   itemsPerPage: number = 25;
 
 
   
  
    totalPages: number = 1;
   //  by date
   searchDate: string = '';  // For storing selected date






   tempRemaData: any[] = [];  // Store the fetched temp Rema data


   // New filter variables
  searchOperator: string = '';
  searchShift: string = '';
  searchMachine: string = '';
  searchClient: string = '';
  searchJobName: string = '';
  searchFromDate: string = '';
  searchToDate: string = '';

  searchTicket: string = '';
 

 constructor( private laminationService: LaminationService, private cdr: ChangeDetectorRef, private activatedRoute: ActivatedRoute,private tempRemaService:TempRemaService,) { }

 ngOnInit(): void {
  //  this.loadAllLaminationProductions();

   this.loadTempRemaData();  // Load the data when the component initializes
 }

allTempRemaData: any[] = [];
// Method to load Temp Rema Data
loadTempRemaData(): void {
  this.tempRemaService.getTempRema().subscribe(
    (data) => {
      console.log('Loaded Temp Rema Data:', data);
      if (Array.isArray(data)) {
        // this.tempRemaData = data.reverse();  // Reverse the array before assigning it;  // Assign data to the variable;  // Assign data to the variable
         this.allTempRemaData = [...data].reverse();
this.tempRemaData = [...this.allTempRemaData];

        this.totalPages = Math.ceil(this.tempRemaData.length / this.itemsPerPage);
        this.updatePaginatedTempRemaData();
        this.filterTable();

        //for implementing searchable dropdown
// client name
        this.clientNames = [
        ...new Set(
          this.tempRemaData
            .map(x => x.clientName)
            .filter(Boolean)
        )
      ];
      // 
this.shiftNames = [
  ...new Set(
    this.tempRemaData
      .map(x => x.shift)
      .filter(Boolean)
  )
];

this.machineNames = [
  ...new Set(
    this.tempRemaData
      .map(x => x.machine)
      .filter(Boolean)
  )
];

this.jobNames = [
  ...new Set(
    this.tempRemaData
      .map(x => x.jobName)
      .filter(Boolean)
  )
];

this.ticketNumbers = [
  ...new Set(
    this.tempRemaData
      .map(x => x.ticketNo)
      .filter(Boolean)
  )
];

this.refNumbers = [
  ...new Set(
    this.tempRemaData
      .map(x => x.refNo)
      .filter(Boolean)
  )
];
      // 
      }

      this.cdr.detectChanges();
    },
    (error) => {
      console.error('Error loading Temp Rema Data:', error);
    }
  );
}

//for implementing searchable dropdown
clientNames: string[] = [];

shiftNames: string[] = [];
machineNames: string[] = [];
jobNames: string[] = [];
ticketNumbers: string[] = [];
refNumbers: string[] = [];
// 
searchRefNo: string = '';

paginatedTempRemaData: any[] = [];

updatePaginatedTempRemaData(): void {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  this.paginatedTempRemaData = this.tempRemaData.slice(startIndex, endIndex);
}

goToPage(page: number): void {
  if (page < 1 || page > this.totalPages) return;
  this.currentPage = page;
  this.updatePaginatedTempRemaData();
}







 // Filter method to apply the filters on the data
 filterTable(): void {
  //  this.loadTempRemaData();
  // let filteredData = this.tempRemaData;
  let filteredData = [...this.allTempRemaData];

   // Log the filter values
  console.log('Search Operator:', this.searchOperator);
  console.log('Search Shift:', this.searchShift);
  console.log('Search Machine:', this.searchMachine);
  console.log('Search Client:', this.searchClient);
  console.log('Search Job Name:', this.searchJobName);
  console.log('Search From Date:', this.searchFromDate);
  console.log('Search To Date:', this.searchToDate);

  // Apply each filter if present
  if (this.searchOperator) {
    filteredData = filteredData.filter(entry => 
      (entry.operator?.toLowerCase() || '').includes(this.searchOperator.toLowerCase())
    );
  }
  if (this.searchShift) {
    filteredData = filteredData.filter(entry => 
      (entry.shift?.toLowerCase() || '').includes(this.searchShift.toLowerCase())
    );
  }
  if (this.searchMachine) {
    filteredData = filteredData.filter(entry => 
      (entry.machine?.toLowerCase() || '').includes(this.searchMachine.toLowerCase())
    );
  }
  if (this.searchClient) {
    filteredData = filteredData.filter(entry => 
      (entry.clientName?.toLowerCase() || '').includes(this.searchClient.toLowerCase())
    );
  }
  if (this.searchJobName) {
    filteredData = filteredData.filter(entry => 
      (entry.jobName?.toLowerCase() || '').includes(this.searchJobName.toLowerCase())
    );
  }
  if (this.searchFromDate) {
    filteredData = filteredData.filter(entry => 
      new Date(entry.date) >= new Date(this.searchFromDate)
    );
  }
  if (this.searchToDate) {
    filteredData = filteredData.filter(entry => 
      new Date(entry.date) <= new Date(this.searchToDate)
    );
  }
   // Manually filter by From and To Date
   // Manually filter by From and To Date
  //  if (this.searchFromDate) {
  //   const fromDate = this.convertDateFormatForComparison(this.searchFromDate);
  //   filteredData = filteredData.filter(entry => 
  //     new Date(entry.date.split('-').reverse().join('-')) >= new Date(fromDate)
  //   );
  // }
  // if (this.searchToDate) {
  //   const toDate = this.convertDateFormatForComparison(this.searchToDate);
  //   filteredData = filteredData.filter(entry => 
  //     new Date(entry.date.split('-').reverse().join('-')) <= new Date(toDate)
  //   );
  // }

  if (this.searchTicket) {
    filteredData = filteredData.filter(entry => 
      (entry.ticketNo?.toLowerCase() || '').includes(this.searchTicket.toLowerCase())
    );
  }

   if (this.searchRefNo) {
  filteredData = filteredData.filter(entry =>
    (entry.refNo?.toLowerCase() || '')
      .includes(this.searchRefNo.toLowerCase())
  );
}

  // Update filtered entries and pagination
  this.tempRemaData = filteredData;
  this.totalPages = Math.ceil(this.tempRemaData.length / this.itemsPerPage);
  this.updatePaginatedTempRemaData();
}

 // Convert date in dd-mm-yyyy format to yyyy-mm-dd for comparison
 convertDateFormatForComparison(date: string): string {
  const [day, month, year] = date.split('-');
  return `${year}-${month}-${day}`;
}
// Format date from yyyy-mm-dd to dd-mm-yyyy for display
formatDateForDisplay(date: string): string {
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
}

clearFilters(): void {
  // Reset all filter variables
  this.searchOperator = '';
  this.searchShift = '';
  this.searchMachine = '';
  this.searchClient = '';
  this.searchJobName = '';
  this.searchFromDate = '';
  this.searchToDate = '';
  this.searchTicket = '';

  // Reload the original data
  this.loadTempRemaData(); // This will reset the table to unfiltered data

  // Reset pagination
  this.currentPage = 1;
  this.totalPages = Math.ceil(this.tempRemaData.length / this.itemsPerPage);
  this.updatePaginatedTempRemaData();

  // Trigger change detection
  this.cdr.detectChanges();
}


// Export to Excel
exportToExcel(): void {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.tempRemaData); // Convert data to sheet
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Rema Records'); // Append sheet to workbook
  XLSX.writeFile(wb, 'Rema_records.xlsx'); // Download as .xlsx file
}



 














 
getTotal(fieldName: string): number {
  return this.tempRemaData.reduce((total, entry) => {
    const value = parseFloat(entry[fieldName]) || 0; // Safely parse the value, default to 0 if NaN
    return total + value;
  }, 0);
}





printRemaData() {

  const printContents = document.getElementById('remaPrintTable')?.outerHTML;

  if (!printContents) {
    alert('No data available to print.');
    return;
  }

  const printWindow = window.open('', '_blank', 'width=1200,height=800');

  if (!printWindow) {
    alert('Please allow pop-ups to print.');
    return;
  }

  printWindow.document.open();

  printWindow.document.write(`
    <html>
      <head>
        <title>Rema Records</title>

        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }

          h2 {
            text-align: center;
            margin-bottom: 20px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 10px;
          }

          th,
          td {
            border: 1px solid #000;
            padding: 6px;
            text-align: center;
          }

          th {
            background-color: #f2f2f2;
            font-weight: bold;
          }

          tfoot td {
            font-weight: bold;
          }

          @media print {
            body {
              margin: 0;
            }

            table {
              page-break-inside: auto;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            thead {
              display: table-header-group;
            }

            tfoot {
              display: table-footer-group;
            }
          }
        </style>
      </head>

      <body>

        <h2>Rema Records</h2>

        ${printContents}

      </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
}
 



}
